import cn from 'classnames'
import React from 'react'

//
import Integration, { IntegrationTypes } from '../Integration'

const MenuIntegrations = ({ title = '', integrations = [], classes = '' }) => {
  return (
    <div className={cn('c-menu-integrations', classes)}>
      {title && (
        <div className="c-menu-integrations__title">
          <h5>{title}</h5>
        </div>
      )}
      <div className="l-grid l-grid--spacing:4">
        {integrations.map((integration) => (
          <div
            key={integration.id || integration.slug}
            className="l-grid__col:12/12 l-grid__col:6/12@at:viewport-7"
          >
            <Integration
              title={integration.title}
              label={integration.label}
              type={integration.type}
              labelType={integration.labelType}
              url={integration.url}
              logo={integration.logo}
              size={IntegrationTypes.medium}
            />
          </div>
        ))}
      </div>
    </div>
  )
}

export default MenuIntegrations
